<template>
  <div class="main-nav-twa d-lg-none">
    <ul class="menu" v-if="isPortalTypeBooks">
      <li v-for="item in menuPortalTypeBooks">
        <a :href="$getSubdomainLink(item.subdomain, item.route)"
           class="menu__item"
           :class="{
              active: $route.path.includes(item.route),
            }"
        >
          <svg width="24" height="24">
            <use :href="`/static/images/sprite/sprite.svg#${item.icon}`"></use>
          </svg>
          <span class="item-text">
            {{ item.name }}
          </span>
        </a>
      </li>
    </ul>
    <ul class="menu"  v-if="!isPortalTypeBooks">
      <li v-for="item in menuPortalTypeDefault">
        <button v-if="item.isBtn" @click="showSearchForm = true" class="menu-search">
          <svg width="24" height="24">
            <use href="/static/images/sprite/sprite.svg#menu-search"/>
          </svg>
        </button>
        <a v-else :href="$getSubdomainLink(item.subdomain, item.route)"
           class="menu__item"
           :class="{
              active: $route.path.includes(item.route),
            }"
        >
          <svg width="24" height="24">
            <use :href="`/static/images/sprite/sprite.svg#${item.icon}`"></use>
          </svg>
          <span class="item-text">
            {{ item.name }}
          </span>
        </a>
      </li>
    </ul>
    <search-form
        v-show="showSearchForm"
        @onBlur="showSearchForm=false"
    />
  </div>
</template>

<script>
import { useAuthStore, useEnabledStore } from "@/stores";
import SearchForm from '@/components/layouts/header/parts/SearchForm.vue';
export default {
  name: "MainNavTwa",
  components: {SearchForm},
  data() {
    return {
      enabledStore: useEnabledStore(),
      authStore: useAuthStore(),
      showSearchForm: false,
    };
  },
  computed: {
    menuPortalTypeBooks() {
      return [
        {
          name: 'Books',
          route: '/books/catalog',
          subdomain: 'portal',
          icon: 'menu-books',
          forAuth: false
        }
      ].filter(item => !item.forAuth || this.isAuth)
    },
    menuPortalTypeDefault () {
      return [
        {
          name: 'plants',
          route: '/plants/catalog',
          subdomain: 'portal',
          icon: 'menu-plants',
          forAuth: false
        },
        {
          name: 'glossary',
          route: '/glossary',
          subdomain: 'portal',
          icon: 'menu-glossary',
          forAuth: true
        },
        {
          name: 'calendar',
          route: '/calendar',
          subdomain: 'portal',
          icon: 'menu-calendar',
          forAuth: false
        },
        {
          isBtn: true,
          id: "search",
          forAuth: false
        },
        {
          name: 'books',
          route: '/books/catalog',
          subdomain: 'portal',
          icon: 'menu-books',
          forAuth: false
        },
        {
          name: 'blog',
          route: '/blog/catalog',
          subdomain: 'portal',
          icon: 'menu-blog',
          forAuth: false
        },
        {
          name: 'profile',
          route: '/my-profile/personal-info',
          subdomain: 'portal',
          icon: 'menu-profile',
          forAuth: true
        }
      ].filter(item => !item.forAuth || this.isAuth)
    },
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks;
    },
    isAuth() {
      return this.authStore.isAuth;
    },
    isPortalTypeLoading() {
      return this.enabledStore.isPortalTypeLoading;
    }
  }
};
</script>

<style
  scoped
  lang="scss"
>
.main-nav-twa {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  padding: 20px 16px;
  background-color: $white;
  border-top: 2px solid $black;
  box-shadow: 0 100px 60px 0 rgba(0, 0, 0, 0.20), 0 58.88px 31.296px 0 rgba(0, 0, 0, 0.14), 0 30.24px 14.688px 0 rgba(0, 0, 0, 0.11), 0 12.16px 6.432px 0 rgba(0, 0, 0, 0.09), 0 2.72px 2.784px 0 rgba(0, 0, 0, 0.06);

  z-index: 100;

  .menu {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .menu__item {
      border: 0;
      @include font(12, 400);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;

      .item-text {
        display: none;
        position: absolute;
        top: 100%;
      }

      svg {
        margin-bottom: 0;
        transition: $transition;
      }

      &.active {
        .item-text {
          display: block;
        }
        svg {
          color: $green;
          margin-bottom: 7px;
        }
      }

    }
  }
}
.menu-search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: $black;
  border-radius: 40px;
  color: $white;
}
:deep(.search-result) {
  top: unset;
  bottom: calc(100% + 64px);
  margin: auto;
  max-width: calc(100% - 36px);
  .search-result__wrapper {
    padding: 8px;
    border-radius: 24px;
    border: 1px solid $green-tint;
    background: $white;
    box-shadow: 0 11.556px 19.111px 0 rgba(0, 0, 0, 0.04), 0 30px 60px 0 rgba(0, 0, 0, 0.07), 0 2.444px 4.889px 0 rgba(0, 0, 0, 0.03);

    .plants-list {
      gap: 8px;
    }
    .plants-list-item {
      font-size: 14px;
      border-radius: 16px;
      padding: 8px 12px 8px 8px;
    }
    .plants-list-item__img {
      width: 20px;
      height: 20px;
      border-radius: 8px;
    }

  }
}
:deep(.search) {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 0;
  right: 0;
  margin: auto;
  max-width: calc(100% - 36px);
  background-color: $white;
  padding: 12px 16px;
  height: 44px;

  .search__btn {
    display: none;
  }
}
</style>